module.exports = __webpack_public_path__ + "media/images/pic/anime/box-blog-type4-425cbc6ed8fdfad5d6e3b7ba16ee0d7c.svg";